import EventService from "src/legacy/services/event.service.jsx";
import {
    TRACKING_EVENT_REQUEST,
    TRACKING_EVENT_SUCCEEDED,
    TRACKING_EVENT_FAILED,
    IDENTIFYING_USER_REQUEST,
    IDENTIFYING_USER_SUCCEEDED,
    IDENTIFYING_USER_FAILED
} from "./actionTypes.jsx";

import {
    TRACK_CONTENT_SEARCH_EVENT, TRACK_ASSET_VIEWED_EVENT,
    TRACK_COLLECTION_VIEWED_EVENT, TRACK_STREAM_ADDED_EVENT,
    TRACK_COLLECTION_CREATED_EVENT, TRACK_COLLECTION_SHARED_EVENT,
    TRACK_ASSET_DOWNLOADED_EVENT,
    TRACK_ASSET_SHARE_LINK_GENERATED_EVENT,
    TRACK_CONVERSATION_VIEWED_EVENT, TRACK_REPORTS_VIEWED_EVENT,
    TRACK_REPORTS_TOGGLED_VIEW_EVENT, TRACK_CONVERSATION_SENT,
    TRACK_CONTENT_HUB_SCREEN_VIEW, TRACK_STREAM_CREATE_SCREEN_VIEW,
    TRACK_BANNER_CREATE_SCREEN_VIEW, TRACK_COLLECTION_LIST_SCREEN_VIEW,
    TRACK_CONTENT_HUB_SWITCH_SCREEN_VIEW, TRACK_CONTENT_HUB_EDIT_SCREEN_VIEW,
    TRACK_SECTION_CREATE_LAYOUT_SCREEN_VIEW, TRACK_SECTION_CREATE_CONTENT_SCREEN_VIEW,
    TRACK_COLLECTION_CREATE_SCREEN_VIEW, TRACK_COLLECTION_EXPERIENCE_CREATE_SCREEN_VIEW,
    TRACK_COLLECTION_VIEWER_CREATE_SCREEN_VIEW, TRACK_COLLECTION_DETAIL_SCREEN_VIEW, TRACK_ASSET_CREATE_SCREEN_VIEW,
    TRACK_ASSET_CREATE_STREAM_COLLECTION_SCREEN_VIEW, TRACK_ASSET_DETAIL_SCREEN_VIEW,
    TRACK_CONVERSATION_LIST_SCREEN_VIEW, TRACK_CONVERSATION_DETAIL_SCREEN_VIEW,
    TRACK_CONVERSATION_PREVIEW_SCREEN_VIEW, TRACK_ASSET_ANALYTICS_SCREEN_VIEW,
    TRACK_ASSET_EDIT_SCREEN_VIEW, TRACK_COMPOSE_SCREEN_VIEW, TRACK_REPORT_SCREEN_VIEW,
    TRACK_ASSET_CLONE_SCREEN_VIEW, TRACK_GENERATE_LINK_SCREEN_VIEW, TRACK_SEARCH_SCREEN_VIEW,
    TRACK_NOTIFICATIONS_LIST_SCREEN_VIEW, TRACK_MANAGE_SOURCE_SCREEN_VIEW, TRACK_LOGGED_IN, TRACK_LOGGED_OUT,TRACK_CONTENT_HUB_SECTION_DELETE_CONFIRMATION_SCREEN_VIEW,
    TRACK_CONTENT_HUB_SECTION_CONTENT_CREATE_SELECTION_TYPE_CONFIRMATION_SCREEN_VIEW,TRACK_SECTION_SAVE_CONFIRMATION_SCREEN_VIEW,TRACK_BANNER_LIST_SCREEN_VIEW,TRACK_COLLECTION_CLONE_CONFIRMATION_SCREEN_VIEW,
    TRACK_COLLECTION_ADD_LOGO_SCREEN_VIEW,TRACK_COLLECTION_EDIT_BANNER_SCREEN_VIEW,TRACK_SECTION_CREATE_SCREEN_VIEW,TRACK_COLLABORATE_EDIT_SCREEN_VIEW,TRACK_LIVE_COLLECTION_CONFIRM_SCREEN_VIEW,TRACK_ADD_COLLECTION_LIST_SCREEN_VIEW,TRACK_SETTINGS_SCREEN_VIEW,
    TRACK_CONTENT_MAP_SCREEN_VIEW,TRACK_CONTENT_HUB_CREATE_STREAM_CLICKED_EVENT,TRACK_CONTENT_HUB_ADD_COVER_IMAGE_CLICKED_EVENT,TRACK_CONTENT_HUB_ADD_BANNER_CLICKED_EVENT,
    TRACK_BANNER_CONTENT_SELECTED_EVENT,TRACK_CROP_BANNER_CLICKED_EVENT,TRACK_CONTENT_HUB_EDIT_HUB_CLICKED_EVENT,TRACK_CONTENT_HUB_MANAGE_CONTENT_CLICKED,TRACK_CONTENT_HUB_CREATE_NEW_SECTION_CLICKED,
    TRACK_CONTENT_HUB_SECTION_MANAGE_CONTENT_CLICKED,TRACK_CONTENT_HUB_SECTION_CONTENT_SELECT_CLICKED,TRACK_CONTENT_HUB_DELETE_SECTION_CLICKED,TRACK_CONTENT_HUB_SECTION_DELETED_CLICKED,TRACK_CONTENT_HUB_SWITCH_CLICKED,TRACK_CONTENT_HUB_CLONE_HUB_CLICKED_EVENT,
    TRACK_CONTENT_HUB_CREATE_ASSET_CLICKED,TRACK_CONTENT_MAP_CLICKED_EVENT,TRACK_CONTENT_HUB_EDIT_CONTENT_CLICKED_EVENT,TRACK_CONTENT_HUB_DELETE_CONTENT_CLICKED,TRACK_CONTENT_HUB_COVER_IMAGE_ADDED,TRACK_CONTENT_HUB_STREAM_CREATED_CLICKED_EVENT,TRACK_CONTENT_HUB_STREAM_CONTENT_LAYOUT_SELECTED_EVENT,
    TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_SELECTED_EVENT,TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_CONFIRMED,TRACK_CONTENT_HUB_ASSET_TYPE_SELECTED,TRACK_CONTENT_HUB_CLONED_EVENT,TRACK_CONTENT_SECTION_MOVED,TRACK_CONTENT_HUB_EDITED_EVENT,
    TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_SAVED,TRACK_CONTENT_HUB_SECTION_CONTENT_REMOVED_EVENT,TRACK_CONTENT_HUB_ASSET_CREATED_EVENT,TRACK_BANNER_CROPPED_EVENT,TRACK_CONTENT_HUB_DESTINATION_SELECTED,
    TRACK_CONTENT_HUB_SWITCHED,TRACK_CONTENT_HUB_SECTION_CONTENT_ADDED_EVENT,TRACK_CONTENT_HUB_SECTION_SAVE_CLICKED,TRACK_CONTENT_HUB_SECTION_CREATED,TRACK_CONTENT_HUB_SECTION_SAVE_CONFIRM_CLICKED,
    TRACK_CONTENT_HUB_SECTION_EDITED,TRACK_GENERATE_LINK_EVENT,TRACK_CREATE_COLLECTION_CLICKED_EVENT,TRACK_RENAME_COLLECTION_CLICKED,
    TRACK_VIEWER_TYPE_SELECTED_EVENT,TRACK_COLLECTION_FILTERED_EVENT,TRACK_CREATE_FOLDER_CLICKED_EVENT,TRACK_FOLDER_CREATED_EVENT,
    TRACK_COLLECTION_RENAMED_EVENT,TRACK_DELETE_COLLECTION_CLICKED,TRACK_COLLECTION_DELETED_EVENT,TRACK_CLONE_COLLECTION_EVENT,TRACK_COLLECTION_CLONED_EVENT,TRACK_EDIT_COLLECTION_CLICKED_EVENT,TRACK_ADD_LOGO_CLICKED_EVENT,TRACK_ADD_LOGO_UPLOAD_CLICKED_EVENT,TRACK_LOGO_UPLOADED_EVENT,
    TRACK_EDIT_BANNER_CLICKED_EVENT,TRACK_CHANGE_EXPERIENCE_CLICKED,TRACK_BANNER_ADDED_EVENT,
    TRACK_FILTER_BANNER_CLICKED_EVENT,TRACK_BANNER_ADDED_COLLECTION_EVENT,TRACK_ADD_SECTION_CLICKED_COLLECTION_EVENT,
    TRACK_IN_ASSET_SEARCH_EVENT,TRACK_ADD_BANNER_CLICKED_COLLECTION_EVENT,TRACK_BANNER_CROPPED_COLLECTION_EVENT,TRACK_BANNER_CONTENT_SELECTED_COLLECTION_EVENT,TRACK_CROP_BANNER_CLICKED_COLLECTION_EVENT,TRACK_EXPEREINCE_TYPE_SELECTED_EVENT,TRACK_CLONE_COLLECTION_CONFIRMATION_EVENT,TRACK_CHANGE_EXPERIENCE_CLICKED_EVENT,TRACK_GENERATE_LINK_CLICKED_EVENT,
    TRACK_ADD_ASSET_CLICKED_COLLECTION_EVENT,TRACK_TEMPLATE_TOGGLE_CLICKED_EVENT,TRACK_LIVE_COLLECTION_TOGGLE_CLICKED_EVENT,TRACK_INTERNAL_USE_ONLY_CLICKED_EVENT,TRACK_COLLABORATE_CLICKED_EVENT,TRACK_LIVE_COLLECTION_TOGGLED_EVENT,TRACK_TEMPLATE_TOGGLED_EVENT,TRACK_SECTION_ADDED_EVENT,TRACK_SECTION_SELECTED_EVENT,TRACK_COLLABORATORS_UPDATED_EVENT,
    TRACK_MORE_OPTIONS_CLICKED_EVENT,TRACK_INTERNAL_USE_ONLY_TOGGLED_EVENT,TRACK_SHARE_COLLECTION_CLICKED,TRACK_BANNER_FILTERED_EVENT,TRACK_ASSET_DETAIL_VIEWED_EVENT,TRACK_ASSET_SOURCE_SELECTED_EVENT,TRACK_ASSET_ADDED,TRACK_ASSET_SHARE_CLICKED_EVENT,TRACK_ASSET_SHARED_EVENT,TRACK_ASSET_DOWNLOADED,TRACK_ASSET_DOWNLOAD_CLICKED,
    TRACK_ANALYTICS_CLICKED_EVENT,TRACK_ADD_TO_COLLECTION_CLICKED_EVENT,TRACK_EDIT_IMAGE_CLICKED_EVENT,TRACK_COLLECTION_SELECTED_EVENT,TRACK_CLONE_ASSET_CLICKED_EVENT,TRACK_EDIT_ASSET_CLICKED_EVENT,TRACK_DOCUMENT_EDIT_CLICKED_EVENT,TRACK_ASSET_EDITED_EVENT,TRACK_ASSET_CLONED_EVENT,
    TRACK_ADD_PAGES_CLICKED_EVENT,TRACK_DESTINATION_SELECTED,TRACK_PAGE_ADDED_EVENT,TRACK_CUSTOM_FIELD_CLICKED_EVENT,TRACK_CUSTOM_FIELD_CREATED_EVENT,TRACK_CREATE_USER_GROUP_CLICKED_EVENT,TRACK_USER_GROUP_CREATED_EVENT,TRACK_INTEGRATIONS_FILTERED_EVENT,TRACK_INTEGRATION_PARTNER_SELECTED_EVENT,TRACK_CONTENT_SOURCE_CLICKED_EVENT,TRACK_INTEGRATIONS_CLICKED_EVENT,TRACK_SOURCE_TYPE_SELECTED_EVENT,TRACK_PLUGIN_CONNECTED_EVENT,TRACK_SOURCE_CONNECTED_EVENT,
    TRACK_GROUP_VIEWED_EVENT, TRACK_ADD_GROUP_CLICKED_EVENT,
    TRACK_ADD_GROUP_CONFIRM_CLICKED_EVENT,
    TRACK_GROUP_ADDED_EVENT,
    TRACK_ADD_ASSET_CLICKED_EVENT,
    TRACK_RENAME_CLICKED_EVENT,
    TRACK_RENAME_CONFIRM_CLICKED_EVENT,
    TRACK_ASSET_RENAMED_EVENT,
    TRACK_GROUP_RENAMED_EVENT,
    TRACK_DELETE_CLICKED_EVENT,
    TRACK_DELETE_CONFIRM_CLICKED_EVENT,
    TRACK_ASSET_DELETED_EVENT,
    TRACK_GROUP_DELETED_EVENT,
    TRACK_COPY_CLICKED_EVENT,
    TRACK_COPY_CONFIRM_CLICKED_EVENT,
    TRACK_ASSET_COPIED_EVENT,
    TRACK_GROUP_COPIED_EVENT,
    TRACK_MOVE_CLICKED_EVENT,
    TRACK_MOVE_CONFIRM_CLICKED_EVENT,
    TRACK_MOVE_STREAM_SELECTED_EVENT,
    TRACK_ASSET_MOVED_EVENT,
    TRACK_GROUP_MOVED_EVENT,
    TRACK_MANAGE_SOURCE_CLICKED_EVENT,
    TRACK_MAP_NEW_FOLDER_CLICKED_EVENT,
    TRACK_CONNECTED_SOURCE_SELECTED_EVENT,
    TRACK_FOLDER_SELECTED_EVENT,
    TRACK_SOURCE_ADDED_EVENT,
    TRACK_EDIT_GROUP_CLICKED_EVENT,
    TRACK_GROUP_EDITED_EVENT,
    TRACK_COPY_STREAM_SELECTED_EVENT,
    TRACK_EDIT_STREAM_CLICKED_EVENT,
    TRACK_EDIT_STREAM_CONFIRM_CLICKED_EVENT,
    TRACK_CHANGE_BACKGROUND_CLICKED_EVENT,
    TRACK_ADD_BANNER_CLICKED_EVENT,
    TRACK_BACKGROUND_IMAGE_ADDED_EVENT,
    TRACK_STREAM_EDITED_EVENT,
    TRACK_DELETE_STREAM_CLICKED_EVENT,
    TRACK_DELETE_STREAM_CONFIRM_CLICKED_EVENT,
    TRACK_STREAM_DELETED_EVENT,
    TRACK_MANAGE_USER_ACCESS_CLICKED_EVENT,
    TRACK_USER_ACCESS_UPDATED_EVENT,
    TRACK_ASSET_SELECTED_EVENT,
    TRACK_SCREEN_VIEW_STREAM_DETAIL,TRACK_SCREEN_VIEW_STREAM_SELECTION,
    TRACK_SCREEN_VIEW_STREAM_EDIT,TRACK_SCREEN_VIEW_STREAM_DELETE,TRACK_SCREEN_VIEW_GROUP_DETAIL,TRACK_SCREEN_VIEW_CONNECTED_SOURCE,TRACK_SCREEN_VIEW_MANAGE_USER_ACCESS,
    TRACK_ATTACH_DOCUMENTS_CLICKED_COMPOSE_EVENT,
    TRACK_INSERT_WIDGET_CLICKED_COMPOSE_EVENT,
    TRACK_SELECT_TEMPLATE_CLICKED_COMPOSE_EVENT,
    TRACK_TEMPLATE_SELECTED_EVENT,
    TRACK_RECOMMENDED_ASSET_CLICKED,
    TRACK_WIDGET_INSERTED_COMPOSE_EVENT,
    TRACK_STREAM_VIEWED_EVENT,
    TRACK_CONVERSATION_CLICKED_EVENT,
    TRACK_SEEK_VIEW_CLICKED_EVENT,
    TRACK_NEW_CHAT_CLICKED_EVENT,
    TRACK_SEARCH_REACTED_EVENT,
    TRACK_SEEK_HISTORY_CLICKED_EVENT,
    TRACK_SEEK_HISTORY_DELETED_EVENT,
    TRACK_DRAFT_AN_EMAIL_CLICKED_EVENT,
    TRACK_ENGAGE_CLICKED_EVENT,
    TRACK_VIEWER_FILTER_APPLIED_EVENT,
    TRACK_MAP_FILTER_APPLIED_EVENT,
    TRACK_ALL_RECIPIENTS_TOGGLED_EVENT,
    TRACK_RECIPIENT_SELECTED_EVENT,
    TRACK_MESSAGE_SENT_EVENT,
    TRACK_GENERATE_LINK_CLICKED,
    TRACK_ASSET_SUMMARISE_CLICKED_EVENT,
    TRACK_ASSET_QUESTION_CLICKED_EVENT,
    TRACK_FILTER_CLUSTER_CREATED_EVENT,
    TRACK_FILTER_CLUSTER_SELECTED_EVENT,
    TRACK_FILTER_CLUSTER_UPDATED_EVENT,
    TRACK_FILTER_CLUSTER_DELETE_CLICKED_EVENT,
    TRACK_FILTER_CLUSTER_DELETED_EVENT,
    TRACK_BULK_ASSET_SELECTED_EVENT,
    TRACK_BULK_ASSET_EDITED_EVENT,
    TRACK_BULK_ASSET_DELETED_EVENT,
    TRACK_EXPORT_CLICKED_EVENT,
    TRACK_CONTENT_MAP_EXPORTED_EVENT
} from '../../constants/eventType.jsx'


import axios from "axios";
import buildUrl from 'build-url-ts';
const apiUrl = process.env.REACT_APP_API_URL;

const ADOPTION_BASE_URL = `${apiUrl}/api/2.0/adoption`;

// identify user
export function identifyUserForAdoption() {

    const distinctId = EventService.getMixpanelDistinctId();

    return function (dispatch) {
        dispatch(identifyingUserForAdoption());

        let url = buildUrl(ADOPTION_BASE_URL, {
            path: `/identify/${distinctId}`
        });

        return axios({
            method: "POST",
            url: url
        }).then((response) => {
            dispatch(identifyingUserForAdoptionSucceeded(response.data));
        }).catch((error) =>
            dispatch(identifyingUserForAdoptionFailed(error))
        );
    };
}

function identifyingUserForAdoption() {
    return {
        type: IDENTIFYING_USER_REQUEST,
        payload: {},
    };
}

function identifyingUserForAdoptionSucceeded(json) {
    
    return {
        type: IDENTIFYING_USER_SUCCEEDED,
        payload: json,
    };
}

function identifyingUserForAdoptionFailed(error) {
    return {
        type: IDENTIFYING_USER_FAILED,
        payload: {
            error: error,
        },
    };
}

// track event
export function trackEventForAdoption(event) {

    const distinctId = EventService.getMixpanelDistinctId();
    if (event && event.properties) {
        event.properties["distinct_id"] = distinctId
        event.properties["platform"] = "Paperflite Web"
    }

    return function (dispatch) {
        dispatch(trackingEventForAdoption());

        let url = buildUrl(ADOPTION_BASE_URL, {
            path: `/event`
        });

        if (event.properties) {
            event.properties = JSON.stringify(event.properties);
        }

        return axios({
            method: "POST",
            url: url,
            data: event
        }).then((response) =>
            dispatch(trackingEventForAdoptionSucceeded(response.data))
        ).catch((error) =>
            dispatch(trackingEventForAdoptionFailed(error))
        );
    };
}

function trackingEventForAdoption() {
    return {
        type: TRACKING_EVENT_REQUEST,
        payload: {},
    };
}

function trackingEventForAdoptionSucceeded(json) {
    return {
        type: TRACKING_EVENT_SUCCEEDED,
        payload: json,
    };
}

function trackingEventForAdoptionFailed(error) {
    return {
        type: TRACKING_EVENT_FAILED,
        payload: {
            error: error,
        },
    };
}


// CUSTOM EVENTS
//content searched event
export function trackAdoptionMetricsForContentSearchEvent(sourceCta, searchString, filter, tags, categories) {

    let properties = {

        source_cta: sourceCta,
        search_string: searchString,
        filter: filter,
        search_tags: tags,
        categories: categories
    }

    let data = {
        event: TRACK_CONTENT_SEARCH_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

export function trackAdoptionMetricsForInAssetSearchEvent(sourceCta,searchString,assetId) {

    let properties = {

        source_cta: sourceCta,
        search_string: searchString,
        asset_id: assetId
    }

    let data = {
        event: TRACK_IN_ASSET_SEARCH_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

// asset detail viewed event
export function trackAdoptionMetricsForAssetDetailViewedEvent(source_cta, asset_type, source_name) {

    const sourceCta = EventService.getSourceNameType(source_cta);

    let properties = {
        source_cta: source_cta,
        asset_type: asset_type,
        [sourceCta]: source_name
    }

    let data = {
        event: TRACK_ASSET_VIEWED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}

//collection detail viewed event
export function trackAdoptionMetricsForCollectionViewedEvent(collectionName) {

    let properties = {
        collection_name: collectionName
    }

    let data = {
        event: TRACK_COLLECTION_VIEWED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}

export function trackAdoptionMetricsForStreamAddedEvent(streamName, streamDescription) {

    let properties = {
        stream_name: streamName,
        stream_description: streamDescription
    }

    let data = {
        event: TRACK_STREAM_ADDED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

export function trackAdoptionMetricsForCollectionCreatedEvent(collectioName,experienceType,viewerType,isAssetAdded,cta) {

    let properties = {
        collection_name: collectioName,
        experience_type : experienceType,
        viewer_type : viewerType,
        isAssetAdded: isAssetAdded,
        cta: cta
    }

    let data = {
        event: TRACK_COLLECTION_CREATED_EVENT,
        properties: properties
    }
    return trackEventForAdoption(data)

}

export function trackAdoptionMetricsForCollectionSharedEvent(collectionName, shareMedium) {
    
    let properties = {
        collection_name: collectionName,
        share_medium: shareMedium
    }

    let data = {
        event: TRACK_COLLECTION_SHARED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

export function trackAdoptionMetricsForAssetSharedEvent(assetType,shareMedium) {

    let properties = {
        asset_type: assetType,
        share_medium: shareMedium
    }

    let data = {
        event: TRACK_ASSET_SHARED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data);

}

// Asset Downloaded

export function trackAdoptionMetricsForAssetDownloadedEvent(collectionName, assetType) {
    
    let properties = {
        collection_name: collectionName,
        asset_type: assetType,
    }

    let data = {
        event: TRACK_ASSET_DOWNLOADED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Asset share clicked 

export function trackAdoptionMetricsForAssetShareClickedEvent(assetType, shareMedium) {
    
    let properties = {

        asset_type: assetType,
        share_medium: shareMedium
    }

    let data = {
        event: TRACK_ASSET_SHARE_CLICKED_EVENT, 
        properties: properties
    }
    
    return trackEventForAdoption(data);

}

export function trackAdoptionMetricsForAssetShareLinkGeneratedEvent(collectionName, assetType, sectionName) {
    
    let properties = {
        collection_name: collectionName,
        asset_type: assetType,
        section_name: sectionName
    }

    let data = {
        event: TRACK_ASSET_SHARE_LINK_GENERATED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//conversation viewed event

export function trackAdoptionMetricsForConversationViewedEvent() {

    let data = {
        event: TRACK_CONVERSATION_VIEWED_EVENT,
        properties: {}
    }
    
    return trackEventForAdoption(data);
}

export function trackAdoptionMetricsForReportsViewedEvent() {

    let data = {
        event: TRACK_REPORTS_VIEWED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

export function trackAdoptionMetricsForReportsToggledViewEvent(tabType) {

    let properties = {
        tab_type: tabType
    }
    let data = {
        event: TRACK_REPORTS_TOGGLED_VIEW_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)

}

export function trackAdoptionMetricsForConversationSentEvent(sourceCta, collectionName, assetType, templateSelected, is_widgetInserted, isAssetsShared, isCollectionShared, recommendedAsset) {

    let properties = {
       source_cta: sourceCta,
       collection_name: collectionName,
       asset_type: assetType,
       isTemplateSelected : templateSelected,
       iswidgetInserted: is_widgetInserted,
       isAttachedAsset: isAssetsShared,
       isAttachedCollection: isCollectionShared,
       isRecommended : recommendedAsset

    }
    let data = {
        event: TRACK_CONVERSATION_SENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

export function trackAdoptionMetricsForLogInEvent() {

    let data = {
        event: TRACK_LOGGED_IN,
        properties: {
        }
    }

    return trackEventForAdoption(data)
}

export function trackLogOut() {
    
    let data = {
        event: TRACK_LOGGED_OUT,
        properties: {
        }
    }

    return trackEventForAdoption(data)
}

// SCREEN VIEWS
// content hub view 
export function trackAdoptionMetricsForContentHubScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONTENT_HUB_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// create stream view
export function trackAdoptionMetricsForCreateStreamScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_STREAM_CREATE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// Banner create view
export function trackAdoptionMetricsForCreateBannerScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_BANNER_CREATE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// collection list view
export function trackAdoptionMetricsForCollectionListScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_LIST_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// content hub switch view

export function trackAdoptionMetricsForContentHubSwitchScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONTENT_HUB_SWITCH_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// content hub edit view
export function trackAdoptionMetricsForContentHubEditScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONTENT_HUB_EDIT_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// section create layout view
export function trackAdoptionMetricsForSectionCreateLayoutScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SECTION_CREATE_LAYOUT_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// section create contnet view
export function trackAdoptionMetricsForSectionCreateContentScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SECTION_CREATE_CONTENT_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// collection create view
export function trackAdoptionMetricsForCreateCollectionScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_CREATE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// collection experience view
export function trackAdoptionMetricsForCollectionExperienceCreateScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_EXPERIENCE_CREATE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// collection viewer create view
export function trackAdoptionMetricsForCollectionViewerCreateScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_VIEWER_CREATE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// collection detail view
export function trackAdoptionMetricsForCollectionDetailScreenView() {
    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_DETAIL_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// asset create view
export function trackAdoptionMetricsForAssetCreateScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_ASSET_CREATE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// Asset Create Stream Collection View 
export function trackAdoptionMetricsForAssetCreateStreamCollectionScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_ASSET_CREATE_STREAM_COLLECTION_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// asset detail screen view
export function trackAdoptionMetricsForAssetDetailScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_ASSET_DETAIL_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// conversation list view
export function trackAdoptionMetricsForConversationListScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONVERSATION_LIST_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// conversation detail view
export function trackAdoptionMetricsForConversationDetailScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONVERSATION_DETAIL_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// conversation preview view
export function trackAdoptionMetricsForConversationPreviewScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONVERSATION_PREVIEW_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// asset analytics
export function trackAdoptionMetricsForAssetAnalyticsScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_ASSET_ANALYTICS_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// asset edit view
export function trackAdoptionMetricsForAssetEditScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_ASSET_EDIT_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// compose view
export function trackAdoptionMetricsForComposeScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COMPOSE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// reports view
export function trackAdoptionMetricsForReportScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_REPORT_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// asset clone view
export function trackAdoptionMetricsForAssetCloneScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_ASSET_CLONE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// generate link view
export function trackAdoptionMetricsForGenerateLinkScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_GENERATE_LINK_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// search view
export function trackAdoptionMetricsForSearchScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SEARCH_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// notification List view
export function trackAdoptionMetricsForNotificationListScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_NOTIFICATIONS_LIST_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// manage source
export function trackAdoptionMetricsForManageSourceScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_MANAGE_SOURCE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}


// content hub section delete confirmation
export function trackAdoptionMetricsForContentHubSectionDeleteConfirmationScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONTENT_HUB_SECTION_DELETE_CONFIRMATION_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// Content Hub Section Content Create Selection Type Confirmation
export function trackAdoptionMetricsForContentHubSectionContentCreateSelectionTypeConfirmationScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONTENT_HUB_SECTION_CONTENT_CREATE_SELECTION_TYPE_CONFIRMATION_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

//Section Save Confirmation

export function trackAdoptionMetricsForSectionSaveConfirmationScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SECTION_SAVE_CONFIRMATION_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

//Banner List

export function trackAdoptionMetricsForBannerListScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_BANNER_LIST_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

//Collection Clone Confirmation

export function trackAdoptionMetricsForCollectionCloneConfirmationScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_CLONE_CONFIRMATION_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

//Collection Add Logo

export function trackAdoptionMetricsForCollectionAddLogoScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_ADD_LOGO_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// Collection Edit Banner

export function trackAdoptionMetricsForCollectionEditBannerScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLECTION_EDIT_BANNER_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

//Section Create

export function trackAdoptionMetricsForSectionCreateScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SECTION_CREATE_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

//Collaborate Edit

export function trackAdoptionMetricsForCollaborateEditScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_COLLABORATE_EDIT_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

//Live Collection Confirm

export function trackAdoptionMetricsForLiveCollectionConfirmScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_LIVE_COLLECTION_CONFIRM_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// collection list 



export function trackAdoptionMetricsForAddCollectionListScreenView() {

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_ADD_COLLECTION_LIST_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}

// settings 

export function trackAdoptionMetricsForSettingsScreenView(){
    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SETTINGS_SCREEN_VIEW 
        }
    }

    return trackEventForAdoption(data)
}

//content map 

export function trackAdoptionMetricsForContentMapScreenView(){
    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_CONTENT_MAP_SCREEN_VIEW
        }
    }

    return trackEventForAdoption(data)
}


//content hub phase 2 
//Create Stream Clicked
export function trackAdoptionMetricsForCreateStreamClickedEvent() {

    let data = {
        event: TRACK_CONTENT_HUB_CREATE_STREAM_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

// add cover image clicked 


export function trackAdoptionMetricsAddCoverImageClickedEvent() {

    let data = {
        event: TRACK_CONTENT_HUB_ADD_COVER_IMAGE_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

// cover image added 


export function trackAdoptionMetricsForCoverImageAddedEvent() {

    let data = {
        event: TRACK_CONTENT_HUB_COVER_IMAGE_ADDED,
        properties: {}
    }

    return trackEventForAdoption(data)
}

// Add Banner Clicked

export function trackAdoptionMetricsForAddBannerClickedEvent(source_cta) {


    let properties = {
        source_cta : source_cta
    }

    let data = {
        event: TRACK_CONTENT_HUB_ADD_BANNER_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Banner Content Selected

export function trackAdoptionMetricsForBannerContentSelectedEvent(bannerType, source_cta) {

    let properties = {

        banner_type : bannerType,
        source_cta : source_cta
    }

    let data = {
        event: TRACK_BANNER_CONTENT_SELECTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}
	
//Crop Banner Clicked

export function trackAdoptionMetricsForCropBannerClickedEvent(bannerType, source_cta) {

    let properties = {
        
        banner_type: bannerType,
        source_cta: source_cta
        
    }

    let data = {
        event: TRACK_CROP_BANNER_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}

//Banner Cropped

export function trackAdoptionMetricsForBannerCroppedEvent(bannerType, source_cta) {

    let properties = {
        banner_type: bannerType,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_BANNER_CROPPED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}

//Banner Added

export function trackAdoptionMetricsForBannerAddedEvent(bannerType, source_cta) {

    let properties = {

        banner_type : bannerType,
        source_cta: source_cta
        
    }

    let data = {
        event: TRACK_BANNER_ADDED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}

// Edit Hub Clicked

export function trackAdoptionMetricsForEditHubClickedEvent() {

    let data = {
        event: TRACK_CONTENT_HUB_EDIT_HUB_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}


// manage content clicked 

export function trackAdoptionMetricsForManageContentClickedEvent() {

    let data = {
        event: TRACK_CONTENT_HUB_MANAGE_CONTENT_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}
// Create new section Clicked


export function trackAdoptionMetricsForCreateNewSectionClicked() {

    let data = {
        event: TRACK_CONTENT_HUB_CREATE_NEW_SECTION_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}
// Section Content Select Clicked

export function trackAdoptionMetricsForSectionContentSelectClicked() {

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECT_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}

//Section Manage Content Clicked

export function trackAdoptionMetricsForSectionManageContentClickedEvent() {

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_MANAGE_CONTENT_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}

//Section Content Selection Saved

export function trackAdoptionMetricsForSectionContentSelectionSavedEvent(contentType){

    
    let properties = {
        content_type : contentType
        

    }
    

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_SAVED, 
        properties: properties
    }

    return trackEventForAdoption(data)
}

//Section Save Clicked

export function trackAdoptionMetricsForSectionSaveClickedEvent(layoutType,layoutPalette){

    
    let properties = {


        layout_type: layoutType,
        layout_palette: layoutPalette,  

    } 

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_SAVE_CLICKED, 
        properties: properties
    }

    return trackEventForAdoption(data)
}

//Section Save Confirm Clicked

export function trackAdoptionMetricsForSectionSaveConfirmClickedEvent(layoutType,layoutPalette){

    
    let properties = {


        layout_type: layoutType,
        layout_palette: layoutPalette, 

    } 

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_SAVE_CONFIRM_CLICKED, 
        properties: properties
    }

    return trackEventForAdoption(data)
}

//Section Edited

export function trackAdoptionMetricsForSectionEditClickedEvent(sectionName,layoutType,layoutPalette){

    
    let properties = {

        section_name: sectionName,
        layout_type: layoutType,
        layout_palette: layoutPalette,
    } 

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_EDITED, 
        properties: properties
    }

    return trackEventForAdoption(data)
}

//Section Created


export function trackAdoptionMetricsForSectionCreatedEvent(sectionName,layoutType,layoutPalette){

    
    let properties = {

        section_name: sectionName,
        layout_type: layoutType,
        layout_palette: layoutPalette, 

    } 

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_CREATED, 
        properties: properties
    }

    return trackEventForAdoption(data)
}

 
// section content removed 

export function trackAdoptionMetricsForSectionContentRemovedEvent(contentType){

    
    let properties = {
        content_type : contentType
        

    }
    

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_CONTENT_REMOVED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)
}

//delete section clicked 

export function trackAdoptionMetricsForDeleteSectionClickedEvent(){

    let data = {
        event: TRACK_CONTENT_HUB_DELETE_SECTION_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}
//section deleted 


export function trackAdoptionMetricsForSectionDeletedEvent(){

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_DELETED_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}

//section moved 


export function trackAdoptionMetricsForSectionMovedEvent(direction){

     
    let properties = {
        direction : direction
        

    }
    

    let data = {
        event:TRACK_CONTENT_SECTION_MOVED, 
        properties: properties
    }

    return trackEventForAdoption(data)
}
//Hub switch clicked 

export function trackAdoptionMetricsForHubSwitchClickedEvent(){

    let data = {
        event: TRACK_CONTENT_HUB_SWITCH_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}


// clone hub clicked  

export function trackAdoptionMetricsForCloneHubClickedEvent(){

    let data = {
        event: TRACK_CONTENT_HUB_CLONE_HUB_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

// content hub cloned 

export function trackAdoptionMetricsForContentHubClonedEvent(layoutName){

    
    let properties = {
        layout_name : layoutName
        
    }
    
    let data = {
        event: TRACK_CONTENT_HUB_CLONED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)
}

// Content Hub Edited

export function trackAdoptionMetricsForContentHubEditedEvent(layoutName){

    
    let properties = {
        layout_name : layoutName
        

    }
    

    let data = {
        event: TRACK_CONTENT_HUB_EDITED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)
}


//create asset clicked 

export function trackAdoptionMetricsForCreateAssetClickedEvent(){

    let data = {
        event: TRACK_CONTENT_HUB_CREATE_ASSET_CLICKED,
        properties: {}
    }

    return trackEventForAdoption(data)
}

// Asset Type Selected 

export function trackAdoptionMetricsForAssetTypeSelectedEvent(assetType){
    

    let properties = {
        asset_type : assetType
        

    }

    let data = {
        event: TRACK_CONTENT_HUB_ASSET_TYPE_SELECTED, 
        properties: properties
    }
   

    return trackEventForAdoption(data)
}


//Content Map Clicked

export function trackAdoptionMetricsForContentMapClickedEvent(){

    let data = {
        event: TRACK_CONTENT_MAP_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

//Edit Content Clicked

export function trackAdoptionMetricsForEditContentClickedEvent(sourceCta, fileType){

    let properties = {
        source_cta: sourceCta,
        asset_type: fileType
    }

    let data = {
        event: TRACK_CONTENT_HUB_EDIT_CONTENT_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//Delete Content Clicked 

export function trackAdoptionMetricsForDeleteContentClickedEvent(sourceCta, assetType){

    let properties = {
        source_cta: sourceCta,
        asset_type: assetType
    }

    let data = {
        event: TRACK_CONTENT_HUB_DELETE_CONTENT_CLICKED,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//Stream Created 

export function trackAdoptionMetricsForStreamCreatedEvent(streamName,isCoverImageAdded,streamDescription) {

    let properties = {
        stream_name: streamName,
        isCoverImageAdded:isCoverImageAdded,
        stream_description: streamDescription

    }

    let data = {
        event: TRACK_CONTENT_HUB_STREAM_CREATED_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}
// Section Content Added

export function trackAdoptionMetricsForSectionContentAddedEvent(contentType) {

    let properties = {
        
        content_type: contentType

    }

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_CONTENT_ADDED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Section Content Layout Selected

export function trackAdoptionMetricsForSectionContentLayoutSelectedEvent(layoutType,layoutPalette) {

    let properties = {
        layout_type: layoutType,
        layout_palette:layoutPalette,
        

    }

    let data = {
        event: TRACK_CONTENT_HUB_STREAM_CONTENT_LAYOUT_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}
//Section Content Selection Type Selected

export function trackAdoptionMetricsForSectionContentSelectionTypeSelectedEvent(selectionType) {

    let properties = {
        selection_type : selectionType,
        

    }

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// section content selection type confirmed 

export function trackAdoptionMetricsForSectionContentSelectionTypeConfirmedEvent(selectionType) {

    let properties = {
        selection_type : selectionType,
        

    }

    let data = {
        event: TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_CONFIRMED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}
//Content Hub Switched

export function trackAdoptionMetricsForContentHubSwitchedEvent(layoutType) {

    let properties = {
        layout_name : layoutType,
        

    }

    let data = {
        event: TRACK_CONTENT_HUB_SWITCHED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Destination selected 


export function trackAdoptionMetricsForDestinationSelectedEvent(assetType,destinationType,sourceCta,collectionName,streamName) {

    let properties = {
        
        asset_type: assetType,
        destination_type : destinationType,
        source_cta : sourceCta,
        collection_name: collectionName,
        stream_name: streamName
        

    }

    let data = {
        event: TRACK_CONTENT_HUB_DESTINATION_SELECTED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


//asset created 


export function trackAdoptionMetricsForAssetCreatedEvent(assetType,collectionName,streamName) {

    let properties = {
        
        asset_type: assetType,
        collection_name: collectionName,
        stream_name: streamName
        

    }

    let data = {
        event: TRACK_CONTENT_HUB_ASSET_CREATED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Get Link Clicked

export function trackAdoptionMetricsForGetLinkEvent(sourceCta,linkType,collectionName) {

    let properties = {

        source_cta : sourceCta,
        link_type: linkType,
        collection_name: collectionName
    }

    let data = {
        event: TRACK_GENERATE_LINK_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// collections - phase 1

// Create Collection Clicked
export function trackAdoptionMetricsForCreateCollectionClickedEvent() {


    let data = {
        event: TRACK_CREATE_COLLECTION_CLICKED_EVENT, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

//Crop Banner Clicked for collection

export function trackAdoptionMetricsForCropBannerClickedCollectionEvent(folioName, bannerType, source_cta) {

    let properties = {

        collection_name: folioName,
        banner_type: bannerType,
        source_cta: source_cta
        
    }

    let data = {
        event: TRACK_CROP_BANNER_CLICKED_COLLECTION_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}
// Viewer Type Selected

export function trackAdoptionMetricsForViewerTypeSelectedEvent(viewerType) {

    let properties = {
        
        viewer_type: viewerType,
        
    }

    let data = {
        event: TRACK_VIEWER_TYPE_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Collection Filtered

export function trackAdoptionMetricsForCollectionFilteredEvent(collectionName) {

    let properties = {
        
    filter_tag : collectionName
        
    }

    let data = {
        event: TRACK_COLLECTION_FILTERED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Banner Cropped for collection

export function trackAdoptionMetricsForBannerCroppedCollectionEvent(collectionName, bannerType, source_cta) {

    let properties = {
        
        collection_name: collectionName,
        banner_type : bannerType,
        source_cta : source_cta
        
    }

    let data = {
        event: TRACK_BANNER_CROPPED_COLLECTION_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}

// Banner content selected for collection

export function trackAdoptionMetricsForBannerContentSelectedCollectionEvent(collectionName, bannerType, source_cta) {

    let properties = {
        collection_name: collectionName,
        banner_type : bannerType,
        source_cta : source_cta
    }

    let data = {
        event: TRACK_BANNER_CONTENT_SELECTED_COLLECTION_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);

}

// Add Banner Clicked for collection 

export function trackAdoptionMetricsForAddBannerForCollectionClickedEvent(source_cta, folioName) {


    let properties = {
        source_cta : source_cta,
        collection_name: folioName
    }

    let data = {
        event: TRACK_ADD_BANNER_CLICKED_COLLECTION_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Create Folder clicked 

export function trackAdoptionMetricsForCreateFolderClickedEvent() {


    let data = {
        event: TRACK_CREATE_FOLDER_CLICKED_EVENT, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

// Folder Created

export function trackAdoptionMetricsFolderCreatedEvent(folderName) {

    let properties = {
        
        folder_name: folderName
        
    }

    let data = {
        event: TRACK_FOLDER_CREATED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Rename Collection Clicked 


export function trackAdoptionMetricsForRenameCollectionClickedEvent() {


    let data = {
        event: TRACK_RENAME_COLLECTION_CLICKED, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

// Collection Renamed

export function trackAdoptionMetricsForCollectionRenamedEvent(oldCollectionName,newCollectionName) {
 
    let properties = {
        
        old_name: oldCollectionName,
        new_name: newCollectionName
        
    }

    let data = {
        event: TRACK_COLLECTION_RENAMED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Delete Collection clicked 

export function trackAdoptionMetricsForDeleteCollectionClickedEvent() {

    let data = {
        event: TRACK_DELETE_COLLECTION_CLICKED, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

// Collection deleted

export function trackAdoptionMetricsForCollectionDeletedEvent(collectionName) {

    let properties = {
        
        collection_name: collectionName
    }

    let data = {
        event: TRACK_COLLECTION_DELETED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// clone collection clicked 

export function trackAdoptionMetricsForCloneCollectionClickedEvent(collectionName) {

    let properties = {
        
        collection_name: collectionName
    }

    let data = {
        event: TRACK_CLONE_COLLECTION_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//clone collection confirmed

export function trackAdoptionMetricsForCloneCollectionConfirmationEvent(collectionName) {

    let properties = {
        
        collection_name: collectionName
    }

    let data = {
        event: TRACK_CLONE_COLLECTION_CONFIRMATION_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Collection Cloned

export function trackAdoptionMetricsForCollectionClonedEvent(collectionName,clonedCollectionName) {

    let properties = {
        
       collection_name: collectionName,
       cloned_collection_name: clonedCollectionName
    }

    let data = {
        event: TRACK_COLLECTION_CLONED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Edit Collection Clicked


export function trackAdoptionMetricsForEditCollectionClickedEvent(collectionName) {

    let properties = {
        
       collection_name: collectionName,
       
    }

    let data = {
        event: TRACK_EDIT_COLLECTION_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Add Logo Clicked

export function trackAdoptionMetricsForAddLogoClickedEvent(collectionName) {

    let properties = {
        
       collection_name: collectionName,
       
    }

    let data = {
        event: TRACK_ADD_LOGO_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Add Logo Upload Clicked

export function trackAdoptionMetricsForAddLogoUploadClickedEvent(collectionName) {

    let properties = {
        
       collection_name: collectionName,
       
    }

    let data = {
        event: TRACK_ADD_LOGO_UPLOAD_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Logo uploaded 


export function trackAdoptionMetricsForLogoUploadedEvent(collectionName) {

    let properties = {
        
       collection_name: collectionName,
       
    }

    let data = {
        event: TRACK_LOGO_UPLOADED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Edit banner clicked

export function trackAdoptionMetricsForEditBannerClickedEvent(collectionName) {
    
    
    let properties = {
        
       collection_name: collectionName,
       
    }

    let data = {
        event: TRACK_EDIT_BANNER_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Change Experience Clicked in edit collection

export function trackAdoptionMetricsForChangeExperienceClicked(collectioName) {
    
    
    let properties = {

        collection_name: collectioName
        
    }

    let data = {
        event: TRACK_CHANGE_EXPERIENCE_CLICKED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}




// change experience clicked in create new collection

export function trackAdoptionMetricsForChangeExperienceEvent() {
    
    
    let properties = {
        
    }

    let data = {
        event: TRACK_CHANGE_EXPERIENCE_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}




// Experience Type selected 

export function trackAdoptionMetricsForExperienceTypeSelectedEvent(collectionName,cta,experienceType) {
    
    
    let properties = {
         
        collection_name: collectionName,
        cta: cta,
        experience_type: experienceType,
        

    }

    let data = {
        event: TRACK_EXPEREINCE_TYPE_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// collections phase 2 

// Filter Banner Clicked

export function trackAdoptionMetricsForFilterBannerClickedEvent(collectioName,bannerType,cta) {
    
    
    let properties = {

        collection_name: collectioName,
        banner_type: bannerType,
        cta : cta
        
    }

    let data = {
        event: TRACK_FILTER_BANNER_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Banner Filtered

export function trackAdoptionMetricsForBannerFilteredEvent(collectioName,bannerType,cta) {
    
    
    let properties = {

        collection_name: collectioName,
        banner_type : bannerType,
        cta: cta
        
    }

    let data = {
        event: TRACK_BANNER_FILTERED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}



// Banner added for collection

export function trackAdoptionMetricsForBannerAddedCollectionEvent(collectionName,bannerType, source_cta) {
    
    
    let properties = {

        collection_name: collectionName,
        banner_type: bannerType,
        source_cta: source_cta
        
    }

    let data = {
        event: TRACK_BANNER_ADDED_COLLECTION_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Add section clicked


export function trackAdoptionMetricsForAddSectionClickedEvent(collectionName) {
    
    
    let properties = {

        collection_name: collectionName
        
    }

    let data = {
        event: TRACK_ADD_SECTION_CLICKED_COLLECTION_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Generate Link clicked 


export function trackAdoptionMetricsForGenerateLinkClickedEvent(collectionName,cta) {
    
    
    let properties = {

        collection_name: collectionName,
        source_cta : cta
        
    }

    let data = {
        event: TRACK_GENERATE_LINK_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Add Asset clicked in collection 

export function trackAdoptionMetricsForAddAssetClickedCollectionEvent(collectionName,entityType) {
    
    
    let properties = {

        collection_name: collectionName,
        add_type: entityType
    }

    let data = {
        event: TRACK_ADD_ASSET_CLICKED_COLLECTION_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Live Collection Toggle Clicked

export function trackAdoptionMetricsForLiveCollectionClickedEvent(collectionName) {
    
    
    let properties = {

        collection_name: collectionName
    }

    let data = {
        event: TRACK_LIVE_COLLECTION_TOGGLE_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}
// Live Collection Toggled

export function trackAdoptionMetricsForLiveCollectionEvent(collectionName,isCollectionLive,notifyRecipient) {
    
    
    let properties = {

        collection_name: collectionName,
        live_status: isCollectionLive,
        notify_recipient: notifyRecipient
    }

    let data = {
        event: TRACK_LIVE_COLLECTION_TOGGLED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Template Toggle clicked

export function trackAdoptionMetricsForTemplateToggleClickedEvent(collectionName) {
    
    
    let properties = {

        collection_name: collectionName
    }

    let data = {
        event: TRACK_TEMPLATE_TOGGLE_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Template Toggled


export function trackAdoptionMetricsForTemplateToggledEvent(collectionName,isTemplateLive) {
    
    
    let properties = {

        collection_name: collectionName,
        template_status: isTemplateLive
    }

    let data = {
        event: TRACK_TEMPLATE_TOGGLED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Internal Use only clicked event 


export function trackAdoptionMetricsForInternalUseOnlyClickedEvent(collectionName) {
    
    
    let properties = {

        collection_name: collectionName
    }

    let data = {
        event: TRACK_INTERNAL_USE_ONLY_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Internal Use only Toggled


export function trackAdoptionMetricsForInternalUseOnlyToggledEvent(collectionName,isInternalUseOnlyLive) {
    
    
    let properties = {

        collection_name: collectionName,
        internal_use_status : isInternalUseOnlyLive
    }

    let data = {
        event: TRACK_INTERNAL_USE_ONLY_TOGGLED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Collaborate clicked 


export function trackAdoptionMetricsForCollaborateClickedEvent(collectionName) {
    
    
    let properties = {

        collection_name: collectionName
    }

    let data = {
        event: TRACK_COLLABORATE_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Collaborate updated 

export function trackAdoptionMetricsForCollaborateUpdatedEvent(collectionName) {
    
    
    let properties = {

        collection_name: collectionName
    }

    let data = {
        event: TRACK_COLLABORATORS_UPDATED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Section Added 

export function trackAdoptionMetricsForSectionAddedEvent(collectionName,sectionName) {
    
    
    let properties = {

        collection_name: collectionName,
        section_name: sectionName
    }

    let data = {
        event: TRACK_SECTION_ADDED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Section Selected

export function trackAdoptionMetricsForSectionSelectedEvent(collectionName,sectionName) {
    
    
    let properties = {

        collection_name: collectionName,
        section_name: sectionName
    }

    let data = {
        event: TRACK_SECTION_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// More Options clicked 

export function trackAdoptionMetricsForMoreOptionsClickedEvent(collectionName) {
    
    
    let properties = {

        collection_name: collectionName,

    }

    let data = {
        event: TRACK_MORE_OPTIONS_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// share Collection clicked 

export function trackAdoptionMetricsForShareCollectionClickedEvent(collectionName,type) {
    
    
    let properties = {

        collection_name: collectionName,
        share_medium: type

    }

    let data = {
        event: TRACK_SHARE_COLLECTION_CLICKED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// asset 

// Asset source selected 

export function trackAdoptionMetricsForAssetSourceSelectedEvent(collection_name, stream_name, source_group_name ,source_type, source_cta) {
    
    
    let properties = {

        collection_name: collection_name,
        stream_name: stream_name,
        source_group_name: source_group_name,
        source_type: source_type,
        source_cta: source_cta

    }

    let data = {
        event: TRACK_ASSET_SOURCE_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Asset Added

export function trackAdoptionMetricsForAssetAddedEvent(source_type, asset_type, stream_name, collection_name, source_group_name, source_cta) {
    
    let properties = {
        source_type: source_type,
        asset_type: asset_type,
        stream_name: stream_name,
        collection_name: collection_name,
        source_group_name: source_group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_ASSET_ADDED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Asset Download Clicked

export function trackAdoptionMetricsForAssetDownloadClickedEvent(fileType) {
    
    
    let properties = {

        asset_type : fileType
    }

    let data = {
        event: TRACK_ASSET_DOWNLOAD_CLICKED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Generate Link Clicked


export function trackAdoptionMetricsForGenerateLinkClicked(assetType,sourceCta) {
    
    
    let properties = {

        asset_type: assetType,
        source_cta: sourceCta

    }

    let data = {
        event: TRACK_GENERATE_LINK_CLICKED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Analytics clicked 


export function trackAdoptionMetricsForAnalyticsClicked(fileType) {
    
    
    let properties = {

        asset_type: fileType   
    }

    let data = {
        event: TRACK_ANALYTICS_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Add to collection clicked

export function trackAdoptionMetricsForAddToCollectionClickedEvent(fileType) {
    
    
    let properties = {
        asset_type: fileType
    }

    let data = {
        event: TRACK_ADD_TO_COLLECTION_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}


// Edit Image Clicked 

export function trackAdoptionMetricsForEditImageClicked() {

    let data = {
        event: TRACK_EDIT_IMAGE_CLICKED_EVENT, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

// Collection selected 

export function trackAdoptionMetricsForCollectionSelectedEvent(assetType, collectionName, sectionName) {
    
    
    let properties = {
        asset_type: assetType,
        collection_name: collectionName,
        section_name: sectionName

    }

    let data = {
        event: TRACK_COLLECTION_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Clone Asset clicked 



export function trackAdoptionMetricsForCloneAssetClickedEvent(fileType) {
    
    
    let properties = {

        asset_type: fileType
    }

    let data = {
        event: TRACK_CLONE_ASSET_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Edit Asset Clicked

export function trackAdoptionMetricsForEditAssetClickedEvent(fileType) {
    
    
    let properties = {

        asset_type: fileType
    }

    let data = {
        event: TRACK_EDIT_ASSET_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Document Edit clicked 

export function trackAdoptionMetricsDocumentEditClickedEvent() {
    

    let data = {
        event: TRACK_DOCUMENT_EDIT_CLICKED_EVENT, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

// Asset edited 


export function trackAdoptionMetricsForAssetEditedEvent(assetType, internalDescription, externalDescription, tags, shareAccess, downloadAccess, categories, sourceCta) {
    
    let properties = {
        asset_type: assetType,
        internal_description: internalDescription,
        external_description: externalDescription,
        tags: tags,
        share_access: shareAccess,
        download_access: downloadAccess,
        categories: categories,
        source_cta: sourceCta
    }

    let data = {
        event: TRACK_ASSET_EDITED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Asset cloned 


export function trackAdoptionMetricsForAssetClonedEvent(assetType,destinationType,collectionName,streamName) {

    let properties = {
        
        asset_type: assetType,
        destination_type: destinationType,
        collection_name: collectionName,
        stream_name: streamName
        

    }

    let data = {
        event: TRACK_ASSET_CLONED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Add Pages 

export function trackAdoptionMetricsForAddPagesEvent() {

    let properties = {
        
        

    }

    let data = {
        event: TRACK_ADD_PAGES_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Destination Selected -- add pages


export function trackAdoptionMetricsFoAddPagesDestinationSelectedEvent(assetType,destinationType,sourceCta,collectionName,streamName) {

    let properties = {
        
       asset_type: assetType,
       destination_type:destinationType,
       source_cta: sourceCta,
       collection_name: collectionName,
       stream_name: streamName 

    }

    let data = {
        event: TRACK_DESTINATION_SELECTED, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Pages added 


export function trackAdoptionMetricsPagesAddedEvent() {


    let data = {
        event: TRACK_PAGE_ADDED_EVENT, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

// Settings module



// Add custom field 

export function trackAdoptionMetricsForCustomFieldClickedEvent() {

   
    let data = {
        event: TRACK_CUSTOM_FIELD_CLICKED_EVENT, 
        properties: {}
    }

    return trackEventForAdoption(data)

}


// Custom field Created 

export function trackAdoptionMetricsForCustomFieldCreatedevent(fieldName,helpText,values,isMultiSelectAllowed,isShowInSearchPage) {

    let properties = {
        
        field_name: fieldName,
        help_text: helpText,
        values: values,
        isMultiSelectAllowed: isMultiSelectAllowed,
        isShowInSearchPage: isShowInSearchPage
    }
    let data = {
        event: TRACK_CUSTOM_FIELD_CREATED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Create User Group clicked


export function trackAdoptionMetricsForCreateUserGroupClickedevent() {

    let data = {
        event: TRACK_CREATE_USER_GROUP_CLICKED_EVENT, 
        properties: {}
    }

    return trackEventForAdoption(data)

}

// User group created 


export function trackAdoptionMetricsForUserGroupCreatedevent(groupName,permission,users) {


    let properties = {
    
        group_name: groupName,
        permission: permission,
        users: users

    }

    let data = {
        event: TRACK_USER_GROUP_CREATED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Integrations Filtered 

export function trackAdoptionMetricsForIntegrationsFilteredEvent(filter) {

    let properties = {
        filter : filter
    }

    let data = {
        event: TRACK_INTEGRATIONS_FILTERED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

//Integration Partner Selected

export function trackAdoptionMetricsForIntegrationPartnerSelectedEvent(filter) {

    let properties = {
        partner_name : filter
    }

    let data = {
        event: TRACK_INTEGRATION_PARTNER_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Content source clicked


export function trackAdoptionMetricsForContentSourceClickedEvent(filter) {

    let properties = {
        filter : filter
    }

    let data = {
        event: TRACK_CONTENT_SOURCE_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Source Type selected 

export function trackAdoptionMetricsForSourceTypeSelectedEvent(sourceType) {

    let properties = {
        source_type: sourceType
    }

    let data = {
        event: TRACK_SOURCE_TYPE_SELECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Integrations clicked 

export function trackAdoptionMetricsForIntegrationsClickedEvent(sourceType) {

    let properties = {
        source_type: sourceType
    }

    let data = {
        event: TRACK_INTEGRATIONS_CLICKED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// Plugin connected


export function trackAdoptionMetricsForPluginConnectedEvent(partnerName) {

    let properties = {
        partner_name: partnerName
    }

    let data = {
        event: TRACK_PLUGIN_CONNECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}

// source connected 

export function trackAdoptionMetricsForSourceConnectedEvent(sourceType) {

    let properties = {
        source_type: sourceType
    }

    let data = {
        event: TRACK_SOURCE_CONNECTED_EVENT, 
        properties: properties
    }

    return trackEventForAdoption(data)

}
// screen view for Stream Detail
export function trackAdoptionMetricsForStreamDetailScreenView(){

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SCREEN_VIEW_STREAM_DETAIL
        }
    }

    return trackEventForAdoption(data)
}

// screen view for Stream Selection
export function trackAdoptionMetricsForStreamSelectionScreenView(){

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SCREEN_VIEW_STREAM_SELECTION
        }
    }

    return trackEventForAdoption(data)
}

// screen view for Stream Edit
export function trackAdoptionMetricsForStreamEditScreenView(){

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SCREEN_VIEW_STREAM_EDIT
        }
    }

    return trackEventForAdoption(data)
}

// screen view for  Stream Delete
export function trackAdoptionMetricsForStreamDeleteScreenView(){

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SCREEN_VIEW_STREAM_DELETE
        }
    }

    return trackEventForAdoption(data)
}

// screen view for Group Detail
export function trackAdoptionMetricsForGroupDetailScreenView(){

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SCREEN_VIEW_GROUP_DETAIL
        }
    }

    return trackEventForAdoption(data)
}

// screen view for Manage Source
export function trackAdoptionMetricsForConnectedSourceScreenView(){

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SCREEN_VIEW_CONNECTED_SOURCE
        }
    }

    return trackEventForAdoption(data)
}

// screen view for Manager User Access
export function trackAdoptionMetricsForManageUserAccessScreenView(){

    let data = {
        event: "Page Viewed",
        properties: {
            "screen_name": TRACK_SCREEN_VIEW_MANAGE_USER_ACCESS
        }
    }

    return trackEventForAdoption(data)
}


//stream and group events

//stream detail viewed
export function trackAdoptionMetricsForStreamViewedEvent() {

    let data = {
        event: TRACK_STREAM_VIEWED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

//group detail viewed
export function trackAdoptionMetricsForGroupViewedEvent(source_cta, group_name, stream_name) {

    let properties = {
        source_cta: source_cta,
        group_name: group_name,
        stream_name: stream_name
    }

    let data = {
        event: TRACK_GROUP_VIEWED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//add group click
export function trackAdoptionMetricsForAddGroupClickEvent(stream_name, source_group_name, source_cta){
    let properties = {
        stream_name: stream_name,
        source_group_name: source_group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_ADD_GROUP_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//add group confirm clicked
export function trackAdoptionMetricsForAddGroupConfirmClickEvent(stream_name, group_name, source_group_name, source_cta){
    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        source_group_name: source_group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_ADD_GROUP_CONFIRM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//group added
export function trackGroupAddedEvent(stream_name, group_name, source_group_name, source_cta){
    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        source_group_name: source_group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_GROUP_ADDED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//add asset clicked
export function trackAdoptionMetricsForAddAssetClickedEvent(stream_name, source_group_name, source_cta){
    let properties = {
        stream_name: stream_name,
        source_group_name: source_group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_ADD_ASSET_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//rename clicked
export function trackAdoptionMetricsForRenameClickedEvent(stream_name, source_cta){
    let properties = {
        stream_name: stream_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_RENAME_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//rename confirm clicked
export function trackAdoptionMetricsForRenameConfirmClickedEvent(stream_name, source_cta, asset_name, group_name, asset_type){

    let properties = {
        stream_name: stream_name,
        source_cta: source_cta,
        asset_name: asset_name,
        group_name: group_name,
        asset_type: asset_type
    }

    let data = {
        event: TRACK_RENAME_CONFIRM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//asset renamed
export function trackAdoptionMetricsForAssetRenamedEvent(stream_name, source_cta, asset_name, asset_type){

    let properties = {
        stream_name: stream_name,
        source_cta: source_cta,
        asset_name: asset_name,
        asset_type: asset_type
    }

    let data = {
        event: TRACK_ASSET_RENAMED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//group renamed
export function trackAdoptionMetricsForGroupRenamedEvent(stream_name, source_cta, group_name){

    let properties = {
        stream_name: stream_name,
        source_cta: source_cta,
        group_name: group_name
    }

    let data = {
        event: TRACK_GROUP_RENAMED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//delete clicked
export function trackAdoptionMetricsForDeleteClickedEvent(stream_name, source_cta){
    
    let properties = {
        stream_name: stream_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_DELETE_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//delete confirm clicked
export function trackAdoptionMetricsForDeleteConfirmClickedEvent(stream_name, source_cta, asset_name, group_name, asset_type){

    let properties = {
        stream_name: stream_name,
        source_cta: source_cta,
        asset_name: asset_name,
        group_name: group_name,
        asset_type: asset_type
    }

    let data = {
        event: TRACK_DELETE_CONFIRM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//asset deleted
export function trackAdoptionMetricsForAssetDeletedEvent(source_cta, asset_name, asset_type){

let properties = {
    source_cta: source_cta,
    asset_name: asset_name,
    asset_type: asset_type
}

let data = {
    event: TRACK_ASSET_DELETED_EVENT,
    properties: properties
}

return trackEventForAdoption(data);
}

//group deleted
export function trackAdoptionMetricsForGroupDeletedEvent(stream_name, source_cta, group_name, asset_type){

    let properties = {
        stream_name: stream_name,
        source_cta: source_cta,
        group_name: group_name,
        asset_type: asset_type
    }

    let data = {
        event: TRACK_GROUP_DELETED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//copy clicked
export function trackAdoptionMetricsForCopyClickedEvent(source_stream_name, source_cta){
    
    let properties = {
        source_stream_name: source_stream_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_COPY_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//copy confirm clicked
export function trackAdoptionMetricsForCopyConfirmClickedEvent(source_stream_name, source_cta, asset_name, group_name, asset_type){

    let properties = {
        source_stream_name: source_stream_name,
        source_cta: source_cta,
        asset_name: asset_name,
        group_name: group_name,
        asset_type: asset_type
    }

    let data = {
        event: TRACK_COPY_CONFIRM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//copy stream selected
export function trackAdoptionMetricsForCopyStreamSelectedEvent(source_stream_name, source_cta, asset_name, group_name, asset_type, destination_stream_name){

    let properties = {
        source_stream_name: source_stream_name,
        source_cta: source_cta,
        asset_name: asset_name,
        group_name: group_name,
        asset_type: asset_type,
        destination_stream_name: destination_stream_name
    }

    let data = {
        event: TRACK_COPY_STREAM_SELECTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//asset copied
export function trackAdoptionMetricsForAssetCopiedEvent(source_stream_name, source_cta, asset_name, asset_type, destination_stream_name){

    let properties = {
        source_stream_name: source_stream_name,
        source_cta: source_cta,
        asset_name: asset_name,
        asset_type: asset_type,
        destination_stream_name: destination_stream_name
    }

    let data = {
        event: TRACK_ASSET_COPIED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//group copied
export function trackAdoptionMetricsForGroupCopiedEvent(source_stream_name, source_cta, group_name, destination_stream_name){

    let properties = {
        source_stream_name: source_stream_name,
        source_cta: source_cta,
        group_name: group_name,
        destination_stream_name: destination_stream_name
    }

    let data = {
        event: TRACK_GROUP_COPIED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//move clicked
export function trackAdoptionMetricsForMoveClickedEvent(source_stream_name, source_cta){
    
    let properties = {
        source_stream_name: source_stream_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_MOVE_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//move confirm clicked
export function trackAdoptionMetricsForMoveConfirmClickedEvent(source_stream_name, asset_type, asset_name, group_name, source_cta){

    let properties = {
        source_stream_name: source_stream_name,
        asset_type: asset_type,
        asset_name: asset_name,
        group_name: group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_MOVE_CONFIRM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//move stream selected
export function trackAdoptionMetricsForMoveStreamSelectedEvent(source_stream_name, asset_type, asset_name, group_name, source_cta, destination_stream_name){

    let properties = {
        source_stream_name: source_stream_name,
        asset_type: asset_type,
        asset_name: asset_name,
        group_name: group_name,
        source_cta: source_cta,
        destination_stream_name: destination_stream_name
    }

    let data = {
        event: TRACK_MOVE_STREAM_SELECTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//asset moved
export function trackAdoptionMetricsForAssetMovedEvent(source_stream_name, asset_type, asset_name, source_cta, destination_stream_name){

    let properties = {
        source_stream_name: source_stream_name,
        asset_type: asset_type,
        asset_name: asset_name,
        source_cta: source_cta,
        destination_stream_name: destination_stream_name
    }

    let data = {
        event: TRACK_ASSET_MOVED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//group moved
export function trackAdoptionMetricsForGroupMovedEvent(source_stream_name, group_name, source_cta, destination_stream_name){

    let properties = {
        source_stream_name: source_stream_name,
        group_name: group_name,
        source_cta: source_cta,
        destination_stream_name: destination_stream_name
    }

    let data = {
        event: TRACK_GROUP_MOVED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//manage source clicked
export function trackAdoptionMetricsForManageSourceClickedEvent(stream_name, group_name, source_cta){
    
    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_MANAGE_SOURCE_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//map new folder clicked
export function trackAdoptionMetricsForMapNewFolderClickedEvent(stream_name, group_name, source_cta){
    
    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_MAP_NEW_FOLDER_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//connected source selected
export function trackAdoptionMetricsForConnectedSourceSelectedEvent(stream_name, group_name, source_cta){

    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_CONNECTED_SOURCE_SELECTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//folder selected
export function trackAdoptionMetricsForFolderSelectedEvent(stream_name, group_name, folder_name, source_cta){

    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        folder_name: folder_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_FOLDER_SELECTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//source added
export function trackAdoptionMetricsForSourceAddedEvent(stream_name, group_name, folder_name, source_cta){

    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        folder_name: folder_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_SOURCE_ADDED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//edit group clicked
export function trackAdoptionMetricsForEditGroupClickedEvent(stream_name, group_name, source_cta){
    
    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_EDIT_GROUP_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//group edited
export function trackAdoptionMetricsForGroupEditedEvent(stream_name, group_name, group_description, source_cta){
    
    let properties = {
        stream_name: stream_name,
        group_name: group_name,
        group_description: group_description,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_GROUP_EDITED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//edit stream clicked
export function trackAdoptionMetricsForEditStreamClickedEvent(stream_name){
    
    let properties = {
        stream_name: stream_name
    }

    let data = {
        event: TRACK_EDIT_STREAM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//edit stream confirm click
export function trackAdoptionMetricsForEditStreamConfirmClickedEvent(stream_name, stream_description){
    
    let properties = {
        stream_name: stream_name,
        stream_description: stream_description
    }

    let data = {
        event: TRACK_EDIT_STREAM_CONFIRM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//change background clicked
export function trackAdoptionMetricsForChangeBackgroundClickedEvent(stream_name){
    
    let properties = {
        stream_name: stream_name
    }

    let data = {
        event: TRACK_CHANGE_BACKGROUND_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//background image added
export function trackAdoptionMetricsForBackgroundImageAddedEvent(banner_type, source_cta){
    
    let properties = {
        banner_type: banner_type,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_BACKGROUND_IMAGE_ADDED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//stream edited
export function trackAdoptionMetricsForStreamEditedEvent(stream_name, stream_description){
    
    let properties = {
        stream_name: stream_name,
        stream_description: stream_description
    }

    let data = {
        event: TRACK_STREAM_EDITED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//delete stream clicked
export function trackAdoptionMetricsForDeleteStreamClickedEvent(stream_name){
    
    let properties = {
        stream_name: stream_name
    }

    let data = {
        event: TRACK_DELETE_STREAM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//delete stream confirm clicked
export function trackAdoptionMetricsForDeleteStreamConfirmClickedEvent(stream_name){
    
    let properties = {
        stream_name: stream_name
    }

    let data = {
        event: TRACK_DELETE_STREAM_CONFIRM_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//stream deleted
export function trackAdoptionMetricsForStreamDeletedEvent(stream_name){
    
    let properties = {
        stream_name: stream_name
    }

    let data = {
        event: TRACK_STREAM_DELETED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//manage user access clicked
export function trackAdoptionMetricsForManageUserAccessClickedEvent(stream_name){
    
    let properties = {
        stream_name: stream_name
    }

    let data = {
        event: TRACK_MANAGE_USER_ACCESS_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//user access updated
export function trackAdoptionMetricsForUserAccessUpdatedEvent(){

    let data = {
        event: TRACK_USER_ACCESS_UPDATED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

//asset selected
export function trackAdoptionMetricsForAssetSelectedEvent(source_type, stream_name, collection_name, source_group_name, asset_type, source_cta){
    
    let properties = {
        source_type: source_type,
        stream_name: stream_name,
        collection_name: collection_name,
        source_group_name: source_group_name,
        asset_type: asset_type,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_ASSET_SELECTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//compose events
// compose event Attach Documents Clicked 
export function trackAdoptionMetricsForAttachDocumentsClickedComposeEvent(sourceCta) {

    let properties = {
      source_cta: sourceCta
    }

    let data = {
      event: TRACK_ATTACH_DOCUMENTS_CLICKED_COMPOSE_EVENT,
      properties: properties
    }

    return trackEventForAdoption(data);
}

// compose event Insert Widget Clicked
export function trackAdoptionMetricsForInsertWedgetClickedComposeEvent(sourceCta) {

    let properties = {
      source_cta: sourceCta
    }

    let data = {
      event: TRACK_INSERT_WIDGET_CLICKED_COMPOSE_EVENT,
      properties: properties
    }

    return trackEventForAdoption(data);
}

// compose event Select Template Clicked
export function trackAdoptionMetricsForSelectTemplateClicked(sourceCta) {

    let properties = {
      source_cta: sourceCta,
    }

    let data = {
      event: TRACK_SELECT_TEMPLATE_CLICKED_COMPOSE_EVENT,
      properties: properties
    }

    return trackEventForAdoption(data);
}

// compose event Template Selected
export function trackAdoptionMetricsForTemplateSelected(sourceCta,templateName) {

    let properties = {
      source_cta: sourceCta,
      template_name: templateName,
    }

    let data = {
      event: TRACK_TEMPLATE_SELECTED_EVENT,
      properties: properties
    }

    return trackEventForAdoption(data);
}

// compose event Recommended Asset Clicked
export function trackAdoptionMetricsForRecommendedAssetClicked(sourceCta) {

    let properties = {
      source_cta: sourceCta,
    }

    let data = {
      event: TRACK_RECOMMENDED_ASSET_CLICKED,
      properties: properties
    }

    return trackEventForAdoption(data);
}

// compose event Widget Inserted
export function trackAdoptionMetricsForWidgetInserted(widgetType) {

    let properties = {
      widget_type: widgetType,
    }

    let data = {
      event: TRACK_WIDGET_INSERTED_COMPOSE_EVENT,
      properties: properties
    }

    return trackEventForAdoption(data);
}

//conversation clicked event
export function trackAdoptionMetricsForConversationClickedEvent() {

    let data = {
      event: TRACK_CONVERSATION_CLICKED_EVENT,
      properties: {}
    }

    return trackEventForAdoption(data);
}

//search and seek events

//seek view clicked
export function trackAdoptionMetricsForSeekViewClickedEvent(asset_type, source_cta){

    let properties = {
        asset_type: asset_type,
        source_cta: source_cta
    }

    let data = {
        event: TRACK_SEEK_VIEW_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

///new chat clicked
export function trackAdoptionMetricsForNewChatClickedEvent(sourceCta){

    let properties = {
        source_cta: sourceCta
    }

    let data = {
        event: TRACK_NEW_CHAT_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//search reacted
export function trackAdoptionMetricsForSearchReactedEvent(reactionType, sourceCta){

    let properties = {
        reaction_type: reactionType,
        source_cta: sourceCta
    }

    let data = {
        event: TRACK_SEARCH_REACTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}

//seek history clicked
export function trackAdoptionMetricsForSeekHistoryClickedEvent(){

    let data = {
        event: TRACK_SEEK_HISTORY_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

//seek history deleted
export function trackAdoptionMetricsForSeekHistoryDeletedEvent(){

    let data = {
        event: TRACK_SEEK_HISTORY_DELETED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data)
}

//draft an email clicked
export function trackAdoptionMetricsForDraftAnEmailClickedEvent(fileType, sourceCta){
    
    let properties = {
        asset_type: fileType,
        source_cta: sourceCta
    }

    let data = {
        event: TRACK_DRAFT_AN_EMAIL_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data)
}
//engage events

//engage clicked
export function trackAdoptionMetricsForEngageClickedEvent() {

    let data = {
        event: TRACK_ENGAGE_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

//viewer filter applied
export function trackAdoptionMetricsForViewerFilterAppliedEvent(filter) {
    let properties = {
        filter: filter
    }

    let data = {
        event: TRACK_VIEWER_FILTER_APPLIED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//map filter applied
export function trackAdoptionMetricsForMapFilterAppliedEvent(filter) {
    let properties = {
        filter: filter
    }

    let data = {
        event: TRACK_MAP_FILTER_APPLIED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//all recipients toggled
export function trackAdoptionMetricsForAllRecipientsToggledEvent() {

    let data = {
        event: TRACK_ALL_RECIPIENTS_TOGGLED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

//recipient selected
export function trackAdoptionMetricsForRecipientSelectedEvent() {

    let data = {
        event: TRACK_RECIPIENT_SELECTED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

//message sent
export function trackAdoptionMetricsForMessageSentEvent() {

    let data = {
        event: TRACK_MESSAGE_SENT_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

//in-asset seek
//asset summarise clicked
export function trackAdoptionMetricsForAssetSummariseClickedEvent(asset_type, source_cta) {

  let data = {
    event: TRACK_ASSET_SUMMARISE_CLICKED_EVENT,
    properties: {
      asset_type: asset_type,
      source_cta: source_cta
    }
  }

  return trackEventForAdoption(data);
}

//asset question clicked
export function trackAdoptionMetricsForAssetQuestionClickedEvent(asset_type, source_cta) {

  let data = {
    event: TRACK_ASSET_QUESTION_CLICKED_EVENT,
    properties: {
      asset_type: asset_type,
      source_cta: source_cta
    }
  }

  return trackEventForAdoption(data);
}

//content map events

//filter cluster created
export function trackAdoptionMetricsForFilterClusterCreatedEvent(filterClusterName, isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter){
    
    let properties = {
        filterClusterName: filterClusterName,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
    }

    let data = {
        event: TRACK_FILTER_CLUSTER_CREATED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//filter cluster selected
export function trackAdoptionMetricsForFilterClusterSelectedEvent(filterClusterName, isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter){
    
    let properties = {
        filterClusterName: filterClusterName,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
    }

    let data = {
        event: TRACK_FILTER_CLUSTER_SELECTED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//filter cluster updated
export function trackAdoptionMetricsForFilterClusterUpdatedEvent(filterClusterName, isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter){
    
    let properties = {
        filterClusterName: filterClusterName,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
    }

    let data = {
        event: TRACK_FILTER_CLUSTER_UPDATED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//filter cluster delete clicked
export function trackAdoptionMetricsForFilterClusterDeleteClickedEvent(filterClusterName){
    
    let properties = {
        filterClusterName: filterClusterName
    }

    let data = {
        event: TRACK_FILTER_CLUSTER_DELETE_CLICKED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//filter cluster deleted
export function trackAdoptionMetricsForFilterClusterDeletedEvent(filterClusterName, isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter){
   
    let properties = {
        filterClusterName: filterClusterName,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
    }

    let data = {
        event: TRACK_FILTER_CLUSTER_DELETED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//bulk asset selected
export function trackAdoptionMetricsForBulkAssetSelectedEvent(){

    let data = {
        event: TRACK_BULK_ASSET_SELECTED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

//bulk asset edited
export function trackAdoptionMetricsForBulkAssetEditedEvent(source_cta){

    let properties = {
        source_cta: source_cta
    }

    let data = {
        event: TRACK_BULK_ASSET_EDITED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//bulk asset deleted
export function trackAdoptionMetricsForBulkAssetDeletedEvent(source_cta){
    
    let properties = {
        source_cta: source_cta
    }

    let data = {
        event: TRACK_BULK_ASSET_DELETED_EVENT,
        properties: properties
    }

    return trackEventForAdoption(data);
}

//export clicked
export function trackAdoptionMetricsForExportClickedEvent(){

    let data = {
        event: TRACK_EXPORT_CLICKED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

//content map exported
export function trackAdoptionMetricsForContentMapExportedEvent(){

    let data = {
        event: TRACK_CONTENT_MAP_EXPORTED_EVENT,
        properties: {}
    }

    return trackEventForAdoption(data);
}

